import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { DomainSearchSuiteModule, SiteSelectorPage } from '@wix/domains-search-suite';
import { DomainsPermissions } from '@wix/domains-serverless-interface';
import { isSelectSiteIntent } from './types';
import { buildMobileConnectStatus } from './mobileConnectStatus';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQueryParams } from '../../hooks/useQueryParams';
export const SelectSiteRoute = _ref => {
  let {
    onSelectSite,
    handlers,
    externalViewer,
    onConnectError,
    onConnectIntro,
    onConnectManual
  } = _ref;
  const {
    getQueryParam
  } = useQueryParams();
  const domainName = getQueryParam('domainName') ?? '';
  const intent = getQueryParam('intent');
  const requiredPermissions = useMemo(() => intent === 'connect' ? [DomainsPermissions.AccountLevelManageDomains] : [DomainsPermissions.AccountLevelPurchaseDomain], [intent]);

  // Reuse the results page's `connect` override so a site picked here resolves
  // through the suite (connect vs. upgrade-paywall) instead of the consumer
  // re-deriving it from the picked site's premium flag.
  const statusesOverrides = useMemo(() => ({
    connect: buildMobileConnectStatus({
      onConnectIntro,
      onConnectManual,
      onConnectError
    })
  }), [onConnectIntro, onConnectManual, onConnectError]);
  if (!isSelectSiteIntent(intent)) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/results"
    });
  }
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      handlers,
      statusesOverrides,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      }
    }
  }, /*#__PURE__*/React.createElement(SelectSiteContent, {
    domainName: domainName,
    intent: intent,
    onSelectSite: onSelectSite,
    onConnectError: onConnectError,
    requiredPermissions: requiredPermissions
  }));
};
const SelectSiteContent = _ref2 => {
  let {
    domainName,
    intent,
    onSelectSite,
    onConnectError,
    requiredPermissions
  } = _ref2;
  useDomainSearchGateBi({
    viewMode: 'Gate Result Page',
    reportGatePageLoadEvents: false,
    useReferralAdditionalInfoAsSearchOrigin: true
  });
  const runDomainAction = DomainSearchSuiteModule.SDK.useRunDomainAction();
  const handleSelectSite = async site => {
    DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
      ctaClick: 'site_selected',
      domain: domainName
    });
    if (intent === 'connect') {
      if (!site.siteId) {
        onConnectError == null || onConnectError();
        return;
      }

      // Let the suite resolve the picked site (connect → Entri divert,
      // non-premium → upgrade paywall, already-assigned → success, ...) and run
      // the resolved action. The connect action is our mobile override.
      try {
        await runDomainAction(domainName, {
          site
        });
      } catch {
        onConnectError == null || onConnectError();
      }
      return;
    }
    onSelectSite == null || onSelectSite({
      domainName,
      intent,
      site
    });
  };
  return /*#__PURE__*/React.createElement(SiteSelectorPage, {
    domainName: domainName,
    requiredPermissions: requiredPermissions,
    onSelectSite: handleSelectSite
  });
};
//# sourceMappingURL=SelectSiteRoute.js.map